import React, { useEffect } from 'react'
// import classNames from 'classnames';
import css from './LandingPageNew.module.css';
import { Link } from 'react-router-dom';
import { FormattedMessage } from '../../util/reactIntl';


import sanFrancisco from '../../assets/images/sanfrancisco.png'
import dallas from '../../assets/images/dallas.png'
import boston from '../../assets/images/boston.png'

const TrendingCardSwiper = ({}) => {
  useEffect(() => {
    // Initialize Swiper
    setTimeout(function() {
      new Swiper('.trending-swiper-container', {
        loop: false,
        slidesPerView: 1.3,
        spaceBetween: 20,
        centeredSlides: true,
        centeredSlidesBounds: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        mousewheel: {
          forceToAxis: true,
          sensitivity: 2,
          releaseOnEdges: false
        },
        breakpoints: {
          768: {
            slidesPerView: 3.7,
            spaceBetween: 15,
            initialSlide: 1,
            autoplay: {
              delay: 1500,
              disableOnInteraction: true
            },
          },
          
          1024: {
            slidesPerView: 2.9,
            spaceBetween: 30,
            initialSlide: 1,
            autoplay: {
              delay: 1500,
              disableOnInteraction: true
            },
          },
        }
      });
    }, 500);
  }, []);

  return (
    <div className="trending-swiper-container" data="trending-swiper-container">
      <div className="swiper-wrapper" data="img-swiper">
        {/*{images.map((src, index) => (
          <div className="swiper-slide" key={index} data="img-swiper-slide">
            <a className={css.cardLink} href="/s">
              <img src="https://t4.ftcdn.net/jpg/03/17/25/45/360_F_317254576_lKDALRrvGoBr7gQSa1k4kJBx7O2D15dc.jpg" alt="card img" className={css.cardImg} />
            </a>
          </div>
        ))}*/}
        
        
        <div className="swiper-slide" data="img-swiper-slide"> 
          <div className={css.trendingCard}>
            <div className={css.trendImgBox}>
              <img src={sanFrancisco} alt="card img" className={css.cardTrendImg} />
            </div>
            <div className={css.trendDetails}>
              <div className={css.location}>San Francisco</div>
            </div>
          </div>
        </div>

        <div className="swiper-slide" data="img-swiper-slide"> 
          <div className={css.trendingCard}>
            <div className={css.trendImgBox}>
              <img src={dallas} alt="card img" className={css.cardTrendImg} />
            </div>
            <div className={css.trendDetails}>
              <div className={css.location}>Dallas</div>
            </div>
          </div>
        </div>

        <div className="swiper-slide" data="img-swiper-slide"> 
          <div className={css.trendingCard}>
            <div className={css.trendImgBox}>
              <img src={boston} alt="card img" className={css.cardTrendImg} />
            </div>
            <div className={css.trendDetails}>
              <div className={css.location}>Boston</div>
            </div>
          </div>
        </div>

      </div>

      <div className="swiper-button-next">
      </div>
      <div className="swiper-button-prev">
      </div>
    </div>
  )
}
export default TrendingCardSwiper;

